import Formatter from '@/models/Formatter'

const capitalize = (value) => value.charAt(0).toUpperCase() + value.slice(1)
const uppercase = (value) => value.toUpperCase()

export default {
  install(Vue) {
    Vue.filter('currency', (value) => {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    })

    Vue.filter('hour', (value) => {
      try {
        let date = new Date(value)
        return date.toLocaleTimeString()
      } catch (e) {
        return ''
      }
    })

    Vue.filter('certificate', value => {
      if (!value)
        return 'Sem certificado'

      let date = new Date(value)
      if (date.toString() === 'Invalid Date')
        return 'Sem certificado'

      let formatted = date.toLocaleString()

      if (date > new Date())
        return `Válido até ${formatted}`
      else
        return `Vencido em ${formatted}`
    })

    Vue.filter('labelCompany', company => {
      if (!company || typeof company !== 'object')
        return ''

      return `${company.name} - ${Formatter.cnpj(company.cnpj)}`
    })

    Vue.filter('key', (value) => {
      if (value.length < 9)
        return value

      const size = value.length
      const start = value.substring(0, 6)
      const end = value.substring(size - 6, size)
      return start + '...' + end
    })

    Vue.filter('price', Formatter.centsToPrice)
    Vue.filter('centsToPrice', Formatter.centsToPrice)

    Vue.filter('datetime', Formatter.stringToDatetime)
    Vue.filter('date', Formatter.stringToDate)

    Vue.filter('cnpj', Formatter.cnpj)
    Vue.filter('cpf', Formatter.cpf)
    Vue.filter('cpfCnpj', Formatter.cpfCnpj)
    Vue.filter('phone', Formatter.phone)

    Vue.filter('t', value => Vue.t(value))
    Vue.filter('capitalize', capitalize)
    Vue.filter('uppercase', uppercase)
  }
}
